/**
 * Defines reducers related to User Entitled Apps feature.
 * this reducer will be combined in the store/RootReducer.js
 */
import * as types from 'constants/ActionTypes';

const initState = {
  thirdPartyAppList: [],
  thirdPartyAppsFetched: false,
  errorToastMessage: '',
  showToast: false,
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.FETCH_USER_ENTITLED_APPS_SUCCESS: {
      const { thirdPartyAppList } = action;
      return {
        ...state,
        thirdPartyAppList,
        thirdPartyAppsFetched: true,
      };
    }
    case types.FETCH_USER_ENTITLED_APPS_ERROR: {
      return {
        ...state,
        showToast: true,
        errorToastMessage: 'ErrorUserEntitledApps',
        thirdPartyAppsFetched: true,
      };
    }
    case types.UPDATE_USER_ONBOARD_STATUS_ERROR: {
      return {
        ...state,
        showToast: true,
        errorToastMessage: 'ErrorUpdatingUserOnboardStatus',
      };
    }
    case types.CLOSE_ERROR_TOAST: {
      return {
        ...state,
        showToast: false,
        errorToastMessage: '',
      };
    }
    default:
      return state;
  }
}
